export default "__VITE_ASSET__70d69911__"